var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPersonalDetails = function SvgPersonalDetails(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -0.33,
    y1: 168.22,
    x2: 174.4,
    y2: 56.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M40.91,0C28.4,0,18.18,10.21,18.18,22.73v154.55c0,12.51,10.22,22.73,22.73,22.73h45.45c2.51,0,4.55-2.04,4.55-4.55s-2.04-4.55-4.55-4.55h-45.45c-7.63,0-13.64-6-13.64-13.64V22.73c0-7.63,6-13.64,13.64-13.64h79.55v31.06c0,7.89,6.5,14.39,14.39,14.39h28.79v68.18c0,2.51,2.04,4.55,4.55,4.55s4.55-2.04,4.55-4.55V50c0-1.12-.41-2.21-1.16-3.05L130.66,1.5C129.79.54,128.56,0,127.27,0H40.91ZM129.55,13.87l28.43,31.59h-23.13c-3.02,0-5.3-2.28-5.3-5.3V13.87ZM45.46,63.64c-2.51,0-4.55,2.04-4.55,4.55s2.04,4.55,4.55,4.55h54.53c2.51,0,4.55-2.04,4.55-4.55s-2.04-4.55-4.55-4.55h-54.53ZM45.46,90.91c-2.51,0-4.55,2.04-4.55,4.55s2.04,4.55,4.55,4.55h95.45c2.51,0,4.55-2.04,4.55-4.55s-2.04-4.55-4.55-4.55H45.46ZM45.46,118.18c-2.51,0-4.55,2.04-4.55,4.55s2.04,4.55,4.55,4.55h54.54c2.51,0,4.55-2.04,4.55-4.55s-2.04-4.55-4.55-4.55h-54.54ZM143.54,126.12c-11.04,0-20.09,9.05-20.09,20.1,0,5.37,2.16,10.24,5.63,13.86-13.94,5.72-23.81,19.43-23.81,35.38,0,2.51,2.04,4.55,4.55,4.55s4.55-2.04,4.55-4.55c0-16.15,13.01-29.15,29.18-29.15s29.19,13,29.19,29.15c0,2.51,2.04,4.55,4.55,4.55s4.55-2.04,4.55-4.55c0-15.95-9.87-29.66-23.81-35.38,3.47-3.61,5.63-8.49,5.63-13.86,0-11.04-9.05-20.1-20.1-20.1ZM143.54,135.21c6.13,0,11.01,4.88,11.01,11.01s-4.88,11-11.01,11-11-4.87-11-11,4.87-11.01,11-11.01ZM45.46,145.45c-2.51,0-4.55,2.04-4.55,4.55s2.04,4.55,4.55,4.55h54.54c2.51,0,4.55-2.04,4.55-4.55s-2.04-4.55-4.55-4.55h-54.54Z",
    vectorEffect: "none",
    style: {
      fill: "url(#b)",
      strokeWidth: 0
    }
  }));
};
export default SvgPersonalDetails;